import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import dotsSrc from '@cover/spaltungstoppen/dots.png';
import redBrushSrc from '@cover/spaltungstoppen/red-brush.png';
import blueShadowSrc from '@cover/spaltungstoppen/blue-shadow.png';
import arrowLeftSrc from '@cover/spaltungstoppen/arrow-left.png';
import arrowRightSrc from '@cover/spaltungstoppen/arrow-right.png';


const AnimatedLayer = styled.img`
	position: absolute;
`

const Dots = styled(AnimatedLayer)`
	z-index: 111;
	transform-origin: top center;
`

const RedBrush = styled(AnimatedLayer)`
	z-index: 222;
`

const BlueShadow = styled(AnimatedLayer)`
	z-index: 333;
	opacity: .8;
`

const BlueShadow2 = styled(AnimatedLayer)`
transform-origin: center center;
	z-index: 333;
`

const ArrowRight = styled(AnimatedLayer)`
	z-index: 555;
	opacity: 0;
`

const ArrowLeft = styled(AnimatedLayer)`
	z-index: 555;
	opacity: 0;
`

const SpaltungStoppen = ({ play }) => {
	const dots = useRef(false);
	const redBrush = useRef(false);
	const blueShadow = useRef(false);
	const arrowLeft = useRef(false);
	const arrowRight = useRef(false);

	useEffect(() => {
		// arrows
		const timeline = anime.timeline({
			autoplay: play,
			loop: true
		});

		timeline
		.add({
			targets: arrowLeft.current,
			easing: 'easeInQuad',
			opacity: 1,
			duration: 200,
			delay: 1800,
			endDelay: 50
		})
		.add({
			targets: arrowRight.current,
			easing: 'easeInQuad',
			opacity: 1,
			duration: 200,
			endDelay: 2700
		})
		.add({
			targets: [arrowLeft.current, arrowRight.current],
			easing: 'easeInQuad',
			duration: 150,
			opacity: 0,
			endDelay: 2000
		});

		// pulsing blue shadow behind woman
		anime({
			targets: blueShadow.current,
			autoplay: play,
			loop: true,
			easing: 'easeInOutSine',
			direction: 'alternate',
			duration: 2400,
			keyframes: [
				{opacity: 0, scale: 1.01},
				{opacity: .95, scale: 1}
			]
		});

		// growing dots
		anime({
			targets: dots.current,
			autoplay: play,
			loop: true,
			easing: 'linear',
			direction: 'alternate',
			duration: 13000,
			scale: 1.3,
			translateY: '-13%'
		});

	}, [play])
	return (
		<>
			<Dots src={dotsSrc} ref={dots} />
			<RedBrush src={redBrushSrc} ref={redBrush} />
			<BlueShadow src={blueShadowSrc} />
			<BlueShadow2 src={blueShadowSrc} ref={blueShadow} />
			<ArrowRight src={arrowRightSrc} ref={arrowRight} />
			<ArrowLeft src={arrowLeftSrc} ref={arrowLeft} />
		</>
	)
};

export default SpaltungStoppen;